import { render, staticRenderFns } from "./CreativesPreview.vue?vue&type=template&id=6b77669c&scoped=true&"
import script from "./CreativesPreview.vue?vue&type=script&lang=js&"
export * from "./CreativesPreview.vue?vue&type=script&lang=js&"
import style0 from "./CreativesPreview.vue?vue&type=style&index=0&id=6b77669c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b77669c",
  null
  
)

export default component.exports